import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { tokenStorage } from '@/api/client'
import { getMe } from '@/api/auth'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user,      setUser]      = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const access = tokenStorage.getAccess()
    if (!access) { setIsLoading(false); return }
    const controller = new AbortController()
    getMe({ signal: controller.signal })
      .then(({ data }) => setUser(data))
      .catch((err) => { if (err.code !== 'ERR_CANCELED') tokenStorage.clearTokens() })
      .finally(() => { if (!controller.signal.aborted) setIsLoading(false) })
    return () => controller.abort()
  }, [])

  useEffect(() => {
    const handle = () => { setUser(null); tokenStorage.clearTokens() }
    window.addEventListener('auth:logout', handle)
    return () => window.removeEventListener('auth:logout', handle)
  }, [])

  const login = useCallback(({ access, refresh, user: u }) => {
    tokenStorage.setTokens({ access, refresh })
    setUser(u)
  }, [])

  const logout = useCallback(() => {
    tokenStorage.clearTokens()
    setUser(null)
  }, [])

  return (
    <AuthContext.Provider value={{ user, isLoading, isAuth: !!user, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be inside <AuthProvider>')
  return ctx
}

